import { Node as SlateNode } from 'slate';
import Graphemer from 'graphemer';

import { onlyPersistentHighlightMarks } from 'src/data/markedText';

export default function serialize(value) {
  const markup = [];
  const splitter = new Graphemer();

  const text = value
    .map((paragraph, index) => {
      // String content of each paragraph in the value's children.
      const paragraphText = SlateNode.string(paragraph);

      // Walk over leafs, and collect marks
      let position = 0;
      paragraph.children.forEach((leaf) => {
        const leafText = SlateNode.string(leaf);
        const leafLength = splitter.countGraphemes(leafText);

        if (leaf.mark) {
          const entry = {
            type: leaf.mark,
            paragraph: index,
            start: position,
            end: position + leafLength,
          };

          markup.push(entry);
        }

        position += leafLength;
      });

      return paragraphText;
    })
    // Join them all with line breaks denoting paragraphs.
    .join('\n');

  // We should save only "persistent" marks
  const persistentMarks = onlyPersistentHighlightMarks(markup);

  return {
    text,
    markup: persistentMarks,
  };
}
